module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-editor"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig,
      "disabled": _vm.disabled
    },
    on: {
      "ready": _vm.setText
    },
    model: {
      value: (_vm.editorData),
      callback: function($$v) {
        _vm.editorData = $$v
      },
      expression: "editorData"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c81ab77!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/Editor.vue
// module id = 2372
// module chunks = 1